import { styled } from 'styled-components';

import { StyledVersionedRouterLink } from '#/components/Link/StyledVersionedRouterLink';
import {
  pageHeaderDesktopHeightWithSearchBar,
  pageHeaderDesktopHeightWithSearchBarAndFilters,
} from '#/components/PageHeader/pageHeaderConstants';
import {
  colors,
  cssBreakpoints,
  fontSizes,
  fontWeights,
  spacing,
} from '#/theme/theme';

export const ListingViewSidebarHolder = styled.aside<{ $withFilters: boolean }>`
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 0;
  position: sticky;
  top: ${(props) =>
    props.$withFilters
      ? `${pageHeaderDesktopHeightWithSearchBarAndFilters}px`
      : `${pageHeaderDesktopHeightWithSearchBar}px`};
  height: 100%;
  padding-top: ${spacing[24]};
  overflow-wrap: break-word;

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) and (max-width: ${cssBreakpoints.lgDown}) {
    width: 308px;
  }

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    width: 418px;
  }
`;

export const ListingViewSidebarInfoBox = styled.div`
  background-color: ${colors.softBlue};
  padding: ${spacing[16]};
  border-radius: 4px;
`;

export const ListingViewSidebarLink = styled(StyledVersionedRouterLink)`
  font-weight: ${fontWeights.normal};
  font-size: ${fontSizes[14]};
`;
